import React, { useState } from 'react';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { getAllowance } from '../../helpers';
import 'react-tabs/style/react-tabs.css';

const ApproveForm = ({
  swapInfo,
  approve,  
  changeState,
  snackMessage,
  userAddress,
  cancel
}) => {
  const [isApproving, setIsApproving] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isTransactionSent, setIsTransactionSent] = useState(false);
 

  const handleApprove = async () => {
    setIsApproving(true);
    const response = await approve();
    if (response.success) {
      handleCheckAllowance();
    }
  };
  const handleCheckAllowance = async () => {
     setIsFetching(true);
    const response = await getAllowance(swapInfo.token.address, userAddress);
     if (response.success) {
      if (parseFloat(response.allowance) >= parseFloat(swapInfo.amounts.sell)) {
         changeState(2) 
      }else if(parseFloat(response.allowance) == parseFloat(swapInfo.allowance)){
         setTimeout(() => {
          handleCheckAllowance();
        }, 3000);
      }else{
         setIsTransactionSent(true);
        setIsApproving(false);
      }
    }else{
      snackMessage(response.message, 'warning')
    }
    setIsFetching(false);
  };

  return (
    <>
      <div className="main info">
        <h6>Approve {swapInfo.token.name}</h6>
        <p className="desc">
          You are about to Receive {swapInfo.amounts.get} OSCAR for{' '}
          {swapInfo.amounts.sell} {swapInfo.token.name}
        </p>

        <ul className="list">
          <li>
            <div className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.8333 4.16667H4.16665C3.24617 4.16667 2.49998 4.91286 2.49998 5.83333V14.1667C2.49998 15.0871 3.24617 15.8333 4.16665 15.8333H15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1667V5.83333C17.5 4.91286 16.7538 4.16667 15.8333 4.16667ZM4.16665 2.5C2.3257 2.5 0.833313 3.99238 0.833313 5.83333V14.1667C0.833313 16.0076 2.3257 17.5 4.16665 17.5H15.8333C17.6743 17.5 19.1666 16.0076 19.1666 14.1667V5.83333C19.1666 3.99238 17.6743 2.5 15.8333 2.5H4.16665Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.8333 9.99967C10.8333 7.69849 12.6988 5.83301 15 5.83301H18.3333C18.7935 5.83301 19.1666 6.2061 19.1666 6.66634C19.1666 7.12658 18.7935 7.49967 18.3333 7.49967H15C13.6193 7.49967 12.5 8.61896 12.5 9.99967C12.5 11.3804 13.6193 12.4997 15 12.4997H18.3333C18.7935 12.4997 19.1666 12.8728 19.1666 13.333C19.1666 13.7932 18.7935 14.1663 18.3333 14.1663H15C12.6988 14.1663 10.8333 12.3009 10.8333 9.99967Z"
                  fill="white"
                />
                <path
                  d="M15.8334 10.0003C15.8334 10.4606 15.4603 10.8337 15 10.8337C14.5398 10.8337 14.1667 10.4606 14.1667 10.0003C14.1667 9.54009 14.5398 9.16699 15 9.16699C15.4603 9.16699 15.8334 9.54009 15.8334 10.0003Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="content">
              <p>Pay</p>
              <h6 className="price">
                {swapInfo.amounts.sell} {swapInfo.token.symbol}
              </h6>
            </div>
          </li>
          <li>
            <div className="icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.8333 4.16667H4.16665C3.24617 4.16667 2.49998 4.91286 2.49998 5.83333V14.1667C2.49998 15.0871 3.24617 15.8333 4.16665 15.8333H15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1667V5.83333C17.5 4.91286 16.7538 4.16667 15.8333 4.16667ZM4.16665 2.5C2.3257 2.5 0.833313 3.99238 0.833313 5.83333V14.1667C0.833313 16.0076 2.3257 17.5 4.16665 17.5H15.8333C17.6743 17.5 19.1666 16.0076 19.1666 14.1667V5.83333C19.1666 3.99238 17.6743 2.5 15.8333 2.5H4.16665Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.8333 9.99967C10.8333 7.69849 12.6988 5.83301 15 5.83301H18.3333C18.7935 5.83301 19.1666 6.2061 19.1666 6.66634C19.1666 7.12658 18.7935 7.49967 18.3333 7.49967H15C13.6193 7.49967 12.5 8.61896 12.5 9.99967C12.5 11.3804 13.6193 12.4997 15 12.4997H18.3333C18.7935 12.4997 19.1666 12.8728 19.1666 13.333C19.1666 13.7932 18.7935 14.1663 18.3333 14.1663H15C12.6988 14.1663 10.8333 12.3009 10.8333 9.99967Z"
                  fill="white"
                />
                <path
                  d="M15.8334 10.0003C15.8334 10.4606 15.4603 10.8337 15 10.8337C14.5398 10.8337 14.1667 10.4606 14.1667 10.0003C14.1667 9.54009 14.5398 9.16699 15 9.16699C15.4603 9.16699 15.8334 9.54009 15.8334 10.0003Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="content">
              <p>Get</p>
              <h6 className="price">{swapInfo.amounts.get} OSCAR</h6>
            </div>
          </li>
          <li>
            <div className="icon">
              <CurrencyExchangeIcon style={{ color: 'white' }} />
            </div>
            <div className="content">
              <p>Fee</p>
              <h6 className="price">
                {swapInfo.fee} {swapInfo.symbol}
              </h6>
            </div>
          </li>
        </ul>
      </div>
      <div className="main payment">
        <h6 className="title">Transfer Details</h6>

        <ul className="status" style={{ marginTop: 15 }}>
          <li>
            <p className="desc">Smart Contract Allowance</p>
            <p
              className="text"
              style={{
                color:
                  parseFloat(swapInfo.allowance) <
                  parseFloat(swapInfo.amounts.sell)
                    ? 'red'
                    : 'green',
              }}
            >
              {swapInfo.allowance}
            </p>
          </li>
          <li>
            <p className="desc">Vesting Period</p>
            <p className="text">{swapInfo.token.vesting_period}</p>
          </li>
          <li>
            <p className="desc">Exchange Rate</p>
            <p className="text">{swapInfo.exchangeRate}</p>
          </li>
          <li>
            <p className="desc">Token</p>
            <p className="text">{swapInfo.token.name}</p>
          </li>
          <li>
            <p className="desc">Address</p>
            <p className="text">
              {swapInfo.token.address ? swapInfo.token.address.slice(0, 5) : ''}
              .....
              {swapInfo.token.address
                ? swapInfo.token.address.slice(
                    swapInfo.token.address.length - 6,
                    swapInfo.token.address.length
                  )
                : ''}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9 20C11.7614 20 14 17.7614 14 15C14 12.2386 11.7614 10 9 10C6.23858 10 4 12.2386 4 15C4 17.7614 6.23858 20 9 20ZM9 22C12.866 22 16 18.866 16 15C16 11.134 12.866 8 9 8C5.13401 8 2 11.134 2 15C2 18.866 5.13401 22 9 22Z"
                  fill="#777E90"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.0001 4C13.5193 4 12.1899 4.6424 11.273 5.66691C10.9047 6.07844 10.2725 6.11346 9.86093 5.74513C9.4494 5.37681 9.41438 4.74461 9.78271 4.33309C11.063 2.9026 12.9268 2 15.0001 2C18.866 2 22.0001 5.13401 22.0001 9C22.0001 11.0733 21.0975 12.937 19.667 14.2173C19.2554 14.5857 18.6232 14.5507 18.2549 14.1391C17.8866 13.7276 17.9216 13.0954 18.3331 12.7271C19.3577 11.8101 20.0001 10.4807 20.0001 9C20.0001 6.23858 17.7615 4 15.0001 4Z"
                  fill="#777E90"
                />
              </svg>
            </p>
          </li>
        </ul>
        <div className="group-button">
          <button className="cancel btn-action-3" onClick={cancel}>
            Cancel
          </button>
          {parseFloat(swapInfo.allowance) < parseFloat(swapInfo.amounts.sell) &&
            isTransactionSent === false && (
              <button
                className="submit btn-action"
                onClick={handleApprove}
                disabled={isApproving === true}
              >
                {isApproving === true ? 'Approving...' : 'Approve'}
              </button>
            )}

          {parseFloat(swapInfo.allowance) < parseFloat(swapInfo.amounts.sell) &&
            isTransactionSent === true && (
              <button
                className="submit btn-action"
                onClick={handleCheckAllowance}
                disabled={isFetching === true}
              >
                {isFetching === true ? 'Fetching...' : 'Check Allowance'}
              </button>
            )}
          {parseFloat(swapInfo.allowance) >=
            parseFloat(swapInfo.amounts.sell) && (
            <button
              className="submit btn-action"
              onClick={() => {
                changeState(2);
              }}
            >
              Continue
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ApproveForm;
